import script from "./RefundIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./RefundIndex.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__